import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PERMISSION_SUPPLIER } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import Suppliers from '../../components/OperationCosts/Suppliers';

export const Route = createFileRoute('/_authenticated/suppliers')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_SUPPLIER, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'menu.suppliersOverview',
        suffix: 'menu.costs',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: SuppliersRoute,
});

function SuppliersRoute() {
  return (
    <>
      {/* Always render the list */}
      <Suppliers />
      {/* Outlet will render child routes (detail modal, etc.) on top */}
      <Outlet />
    </>
  );
}
